<template>
  <div>
    <b-tab title="More like this" @click.prevent="fetchMLT()" title-link-class="bg-info text-white">
      <b-card-text>
      <ListLoader v-if="!mlt || mlt==''"
         :speed="2"
         :animate="true"
       ></ListLoader>
      <div class="morelikethis" v-else>
        <b-card-group columns>
        <b-card v-for="card in mlt" :key="card.id"
            class="card">

          <b-link href="#" v-on:click.prevent="gotoTopic(card.id)"><h4>{{card.sem_title}}</h4></b-link>
          <a v-on:click.prevent="openGraph(card.id, card.sem_title)" class="float-right" href="#"><b-icon icon="diagram-2" font-scale="2" variant="secondary"></b-icon></a>
          <dl>
            <dd v-if="card.sem_record_type">
              <a :href="card.sem_url" target="_blank">{{card.sem_record_type}}</a>
            </dd>
            <!-- <dt v-if="card.sem_abstract">Abstract</dt> -->
            <dd v-for="x in card.sem_abstract" :key="x">{{x}}</dd>
          </dl>
        </b-card>
        </b-card-group>
      </div>

      </b-card-text>
    </b-tab>
  </div>

</template>

<script>
import { ListLoader } from 'vue-content-loader';

export default {
  name: 'morelikethis',
  props: ['url'],
  components: {
    ListLoader
  },
  computed: {
    mlt () {
      if (this.$store.state.mlt &&
          this.$store.state.mlt.response &&
          this.$store.state.mlt.response.docs) {
        return this.$store.state.mlt.response.docs
      } else {
        return '';
      }
    }
  },
  methods: {
    openGraph (nodeId, nodeTitle) {
       this.$router.push({ name: 'visualization', query: { id: nodeId }, params: { nodeTitle: nodeTitle } })
    },
    fetchMLT () {
       this.$store.commit('updateMLT', '');
       this.$store.dispatch('fetchMLT', this.url);
    },
    gotoTopic (id) {
      this.$router.replace({ path: '/detail/' +  id});
    }
  }
}
</script>

<style scoped>

</style>
